function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.521 2.288)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_25338",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 25338",
  d: "M108.609,210.293l-2.76-3.245,2.452-1.4a.5.5,0,1,0-.495-.867l-5.079,2.9-5.079-2.9a.5.5,0,1,0-.495.867l2.452,1.4-2.76,3.245a.5.5,0,1,0,.761.647l2.882-3.389,1.992,1.136a.5.5,0,0,0,.495,0l1.992-1.136,2.882,3.389a.5.5,0,0,0,.761-.647Z",
  transform: "translate(-96.726 -204.716)",
  fill: "#324655"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.546,136H22.5a1.5,1.5,0,0,0-1.5,1.5v8.655a1.5,1.5,0,0,0,1.5,1.5H36.546a1.5,1.5,0,0,0,1.5-1.5V137.5A1.5,1.5,0,0,0,36.546,136Zm.5,10.153a.5.5,0,0,1-.5.5H22.5a.5.5,0,0,1-.5-.5V137.5a.5.5,0,0,1,.5-.5H36.546a.5.5,0,0,1,.5.5Z",
  transform: "translate(-21 -136)",
  fill: "#324655"
}))));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    className: "fill",
    width: 17.044,
    height: 11.651,
    viewBox: "0 0 17.044 11.651",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.f50ff4fe.svg";
export { ForwardRef as ReactComponent };